import Loading from './components/loading'
import Userbar from './components/userbar'
import ListRangeSlider from './components/range-slider/list'

import Slider from './components/slider/slider'
import ScrollingTable from './components/scrolling-table'
import SliderItem from './components/slider/item'
// import SlickSlider from './components/slider/slick'

import CustomModal from './components/modal/modal'
// import ModalContainer from './components/modal/container'
import DatePicker from './components/datepicker'

import Alphabet from './components/alphabet/alphabet'
import AlphabetRecommended from './components/alphabet/recommended'
import AlphabetForbidden from './components/alphabet/forbidden'
import Select from './components/select/select'
import VModal from 'vue-js-modal'
import PlayVideo from './components/PlayVideo'
import CustomSlider from './components/CustomSlider'
import Videos from './components/videos'
import Articles from './components/articles'
import ModalTrigger from './components/ModalTrigger.vue'
import GetInfo from './components/GetInfo'
import GetStagesInfo from './components/GetStagesInfo'
import Login from './components/Login'
import Lightbox from './components/Lightbox'
import UiAccordion from './components/UiAccordion'
import UiClickOutside from '@shared/components/UiClickOutside'
import Share from '@shared/components/Share'

import SearchComponents from './components/search'

import Range from 'vue-slider-component'
import Multiselect from 'vue-multiselect'
import VueObserveVisibility from 'vue-observe-visibility'
import VueClipboard from 'vue-clipboard2'
import VueSocialSharing from 'vue-social-sharing'

export default function install(Vue) {
  Vue.use(VModal, {
    dynamic: true
  })
  Vue.use(VueClipboard)
  Vue.use(VueObserveVisibility)
  Vue.use(VueSocialSharing)
  
  Vue.component('range-slider', Range)
  Vue.component('loading', Loading)
  Vue.component('userbar', Userbar)
  Vue.component('range-slider-list', ListRangeSlider)
  Vue.component('scrolling-table', ScrollingTable)

  Vue.component('slider', Slider)
  Vue.component('slider-item', SliderItem)
  // Vue.component('slick-slider', SlickSlider)

  Vue.component('CustomModal', CustomModal)
  // Vue.component('modal-container', ModalContainer)
  Vue.component('date-picker', DatePicker)

  Vue.component('alphabet', Alphabet)
  Vue.component('alphabet-forbidden', AlphabetForbidden)
  Vue.component('alphabet-recommended', AlphabetRecommended)
  Vue.component('select-styled', Select)
  Vue.component('PlayVideo', PlayVideo)
  Vue.component('ModalTrigger', ModalTrigger)
  Vue.component('CustomSlider', CustomSlider)
  Vue.component('GetInfo', GetInfo)
  Vue.component('GetStagesInfo', GetStagesInfo)
  Vue.component('Login', Login)
  Vue.component('Lightbox', Lightbox)
  Vue.component('UiClickOutside', UiClickOutside)
  Vue.component('UiAccordion', UiAccordion)
  Vue.component('Multiselect', Multiselect)
  Vue.component('Share', Share)
  Vue.use(Videos)
  Vue.use(Articles)
  Vue.use(SearchComponents)
}



// WEBPACK FOOTER //
// ./src/js/shared/index.js